<template>
    <rkm-area
        :closed="closed"
        background-color="primary"
        title="Antropometria"
        type="box"
    >
        <rkm-row>
            <rkm-col :cols="hiddenFields.length > 2 ? '4' : '3'" v-show="!hiddenFields.includes('peso')">
                <rkm-form-input
                    :validations="validations.peso"
                    @change.native="handlePesoChange"
                    @input="handlePesoInput"
                    label="Peso"
                    placeholder="000.000"
                    v-model="data.model.antropometria.peso"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            kg
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col :cols="hiddenFields.length > 2 ? '4' : '3'" v-show="!hiddenFields.includes('altura')">
                <rkm-form-input
                    :validations="validations.altura"
                    @change.native="handleAlturaChange"
                    label="Altura"
                    placeholder="000"
                    v-mask="masks.altura"
                    v-model="data.model.antropometria.altura"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            cm
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col :cols="hiddenFields.length > 2 ? '4' : '3'" v-show="!hiddenFields.includes('imc')">
                <rkm-form-input
                    disabled
                    label="IMC"
                    v-model="data.model.antropometria.imc.imc"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            {{data.model.antropometria.imc.classificacao}}
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col :cols="hiddenFields.length > 2 ? '4' : '3'" v-show="!hiddenFields.includes('perimetroCefalico')">
                <rkm-form-input
                    :validations="validations.perimetroCefalico"
                    @change.native="handlePerimetroCefalicoChange"
                    label="Perímetro cefálico"
                    placeholder="000.0"
                    v-mask="masks.perimetroCefalico"
                    v-model="data.model.antropometria.perimetroCefalico"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            cm
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col :cols="hiddenFields.length > 2 ? '4' : '3'" v-show="!hiddenFields.includes('circunferenciaAbdominal')">
                <rkm-form-input
                    :validations="validations.circunferenciaAbdominal"
                    @change.native="handleCircunferenciaAbdominalChange"
                    label="Circunferência abdominal"
                    placeholder="000"
                    v-mask="masks.circunferenciaAbdominal"
                    v-model="data.model.antropometria.circunferenciaAbdominal"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            cm
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col :cols="hiddenFields.length > 2 ? '4' : '3'" v-show="!hiddenFields.includes('perimetroPanturrilha')">
                <rkm-form-input
                    :validations="validations.perimetroPanturrilha"
                    @change.native="handlePerimetroPanturrilhaChange"
                    label="Perímetro da panturrilha"
                    placeholder="00"
                    v-mask="masks.perimetroPanturrilha"
                    v-model="data.model.antropometria.perimetroPanturrilha"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            cm
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxAntropometria
                    v-if="data.form.antropometria"
                    :data="data.form.antropometria"
                    title="Antropometria realizada na mesma data, durante o acolhimento."
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Enums.
import unidadeMedida from '@/enums/cadastro/unidadeMedida'

// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

import BoxAntropometria from '@/components/ambulatorio/atendimento/components/historico/components/antropometria/Index'

export default {
    components: {
        BoxAntropometria,
    },
    computed: {
        validations() {
            return {
                peso: {
                    min_value: 0.5,
                    max_value: 500,
                    max: 7,
                    required: this.required
                },
                altura: {
                    min_value: 20,
                    max_value: 250,
                    required: this.required
                },
                perimetroCefalico: {
                    min_value: 10,
                    max_value: 200,
                },
                circunferenciaAbdominal: {
                    max_value: 999,
                    required: this.required
                },
                perimetroPanturrilha: {
                    min_value: 10,
                    max_value: 99,
                },
            }
        },
    },
    created() {
        this.repositories = {
            geral: this.getConectaSusRepository('geral'),
        }
    },
    data: () => ({
        enums: {unidadeMedida},
        masks: {
            altura: '###',
            circunferenciaAbdominal: '###',
            perimetroCefalico: '###.#',
            perimetroPanturrilha: '##',
            peso: '###.###',
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handlePesoChange(event) {
            if (!event.target.classList.contains('is-invalid')) {
                this.$emit('pesoChange', event.target.value)

                this.calcularIMC()
            }
        },
        handleAlturaChange(event) {
            if (!event.target.classList.contains('is-invalid')) {
                this.$emit('alturaChange', event.target.value)

                this.calcularIMC()
            }
        },
        handlePerimetroCefalicoChange(event) {
            if (!event.target.classList.contains('is-invalid')) {
                this.$emit('perimetroCefalicoChange', event.target.value)
            }
        },
        handleCircunferenciaAbdominalChange(event) {
            if (!event.target.classList.contains('is-invalid')) {
                this.$emit('circunferenciaAbdominalChange', event.target.value)
            }
        },
        handlePerimetroPanturrilhaChange(event) {
            if (!event.target.classList.contains('is-invalid')) {
                this.$emit('perimetroPanturrilhaChange', event.target.value)
            }
        },
        calcularIMC() {
            if (!this.data.model.antropometria.peso || !this.data.model.antropometria.altura) {
                this.data.model.antropometria.imc.imc = null
                this.data.model.antropometria.imc.classificacao = null
            } else {
                this.setLoading()

                const request = {
                    unidade_medida_massa_id: this.enums.unidadeMedida.QUILOGRAMAS,
                    massa: this.data.model.antropometria.peso,
                    unidade_medida_altura_id: this.enums.unidadeMedida.CENTIMETROS,
                    altura: this.data.model.antropometria.altura,
                }

                this.repositories.geral.calcularIMC(request)
                    .then(response => {
                        this.data.model.antropometria.imc = response.data
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handlePesoInput(e) {

            let value = e.replace(/\D/g, '')

            if (!value) {
                this.data.model.antropometria.peso = ''
                return
            }

            if (value.length === 1) {
                this.data.model.antropometria.peso = value
            } else if (value.length === 2) {
                this.data.model.antropometria.peso = value[0] + '.' + value[1]
            } else if (value.length === 3) {
                this.data.model.antropometria.peso = value[0] + '.' + value.slice(1)
            } else if (value.length === 4) {
                this.data.model.antropometria.peso = value[0] + '.' + value.slice(1)
            } else if (value.length === 5) {
                this.data.model.antropometria.peso = value.slice(0, 2) + '.' + value.slice(2)
            } else {
                this.data.model.antropometria.peso = value.slice(0, 3) + '.' + value.slice(3, 6)
            }
        },
    },
    mixins: [error, repository, stringCase],
    props: {
        closed: {type: Boolean, default: false},
        required: {type: Boolean, default: false},
        data: {type: Object, required: true},
        hiddenFields: {type: Array, default: () => []}
    },
}
</script>